<template>
    <v-select
        :onChange="(e) => selected(e)"
        :options="books"
        :value="selectedBook"
        label="title"
        class="mb-3"
        placeholder="Notebook type"
    ></v-select>
</template>

<script>
    import DownArrow from "../ui/DownArrow.vue";
    import { API_URL } from "../../env.js";
    import qs from "query-string";
    import vSelect from "vue-select";


    export default {
        name: "move-dropdown",
        mounted() {
            this.selectedBook = this.note.book;
        },
        props: ["note"],
        data() {
            return {
                choosing: false,
                selectedBook: '',
            };
        },
        methods: {
            selected(selected) {
                console.log('selected', selected);
                if (selected.id !== this.note.book.id) {
                    this.moveNotesToBook(selected);
                }
            },
            toggleChoosing: function(e) {
                e.preventDefault();
                this.choosing = !this.choosing;
            },
            async moveNotesToBook(book) {
                this.$loading(true);
                // Check buffer before deleting note.
                // If viewing a note in a book, get some buffer notes if none exist or if the user has changed the URL (paginated, filtered, searched, etc.)
                if (this.$route.query.book) {
                    const queryString = qs.stringify(this.$route.query);
                    const shouldGetBufferNotes = queryString !== this.notesFetchKey || this.bufferNotes.length === 0;
                    if (shouldGetBufferNotes) {
                        let search = Object.assign({}, this.$route.query);
                        search.page = search.page ? search.page + 1 : 2;
                        let nextPageQuery = qs.stringify(search);
                        const uri = `${API_URL}/admin/notes?${nextPageQuery}`;
                        await this.$store.dispatch("aGetBufferNotes", {
                            uri,
                            notesFetchKey: queryString
                        });
                    }
                    // Move one note from buffer to current list.
                    this.$store.dispatch("aMoveBufferNotes", 1);
                }

                // Update the note's book
                this.note.book = book;
                this.note.book_id = book.id;
                const notes = [this.note];
                // aUpdateNotes updates the note in the list and the server
                this.$store.dispatch("aUpdateNotes", { notes }).then(() => {
                    if (this.$route.query.book) {
                        // Remove the note from the current list (after it's updated)
                        this.$store.dispatch("aRemoveNote", this.note.id);
                    }
                    this.$loading(false);
                });
            },
        },
        computed: {
            book() {
                return this.note.book;
            },
            books() {
                return this.$store.state.notes.books;
            },
            bufferNotes() {
                return this.$store.state.notes.bufferNotes;
            },
            notesFetchKey() {
                return this.$store.state.notes.notesFetchKey;
            }
        },
        components: {
            DownArrow,
            "v-select": vSelect,
        }
    };
</script>

<style lang="scss">
    .down-arrow {
        max-width: 10px;
        top: 4px;
        position: relative;
        right: 5px;
    }
</style>
